import { useCallback, useState } from "react";

export const useBoolean = (initial = false) => {
  const [value, setValue] = useState(initial);
  const toggle = useCallback(() => setValue((p) => !p), []);
  return [value, toggle, setValue] as const;
};
